/**
 * @fileoverview POST handler for the "/apps/:app_id/upload_push_certificate" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppIdUploadPushCertificateCacheKeys } from "./constants";
import type { PostAppsAppIdUploadPushCertificateProps, AppsAppIdUploadPushCertificateResult } from "./types";

export const postAppsAppIdUploadPushCertificate = reactQueryMutationAdapter(
  appsAppIdUploadPushCertificateCacheKeys,
  (props: PostAppsAppIdUploadPushCertificateProps): Promise<AppsAppIdUploadPushCertificateResult> => {
    return fetch(
      `/apps/${props.appId}/upload_push_certificate`,
      "POST",
      {},
      { body: props.formData },
      { setContentType: false, propagateFetchRequestError: false }
    );
  }
);
